import React from 'react';
import {IKnowledgeSubmissionQuestion} from '../../hooks/apis/useKnowledgeSubmission';
import {Divider, Radio, Space, Checkbox} from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import {KnowledgeQuestionType} from '../../hooks/apis/useKnowledgeBank';
import Text from 'antd/lib/typography/Text';

export default function KnowledgeQuestionSubmitItem(props: {
  question: IKnowledgeSubmissionQuestion;
  onChange?: (question: IKnowledgeSubmissionQuestion) => any;
  disabled?: boolean;
  showResult?: boolean;
}) {
  const question = props.question;
  const radioStyle = {
    display: 'block',
    lineHeight: '30px',
  };
  const labels = 'ABCD';
  return (
    <React.Fragment>
      <Divider orientation={'left'}>
        第 {question.index} 题{' '}
        {props.showResult && (
          <React.Fragment>
            {question.scoreGet === question.score && <Text type={'success'}>正确</Text>}
            {question.scoreGet === 0 && <Text type={'danger'}>错误</Text>}
            {question.scoreGet !== 0 && question.scoreGet < question.score && <Text type={'danger'}>部分正确</Text>}
          </React.Fragment>
        )}
      </Divider>
      <div style={{width: '100%', paddingLeft: 20}}>
        <Paragraph style={{textAlign: 'left'}}>
          [{KnowledgeQuestionType[question.type]}] {question.topic}
        </Paragraph>
        <div className={'mb-md'}>
          {question.type === KnowledgeQuestionType.单选题 && <Text type={'secondary'}>单选，仅有 1 项正确答案</Text>}
          {question.type === KnowledgeQuestionType.多选题 && (
            <div>
              <Text type={'secondary'}>多选，有 1-4 项正确答案</Text>
              <br />
              <Text type={'secondary'}>全部选对得满分，部分选对得一半分，选错或不选得 0 分</Text>
            </div>
          )}
        </div>
        {question.type === KnowledgeQuestionType.单选题 && (
          <Radio.Group
            disabled={props.disabled}
            onChange={e => {
              props.onChange && props.onChange({...question, choices: [e.target.value]});
            }}
            value={question.choices[0]}>
            {question.options.map((opt, i) => (
              <Space key={opt}>
                <Radio style={radioStyle} value={opt} key={opt}>
                  <p style={{marginLeft: 30, marginTop: -30, width: 550, marginBottom: -30, wordWrap: 'break-word', whiteSpace: 'normal'}}>
                    {labels[i]}. {opt}
                  </p>
                </Radio>
              </Space>
            ))}
          </Radio.Group>
        )}
        {question.type === KnowledgeQuestionType.多选题 && (
          <Checkbox.Group
            disabled={props.disabled}
            style={{lineHeight: '30px'}}
            onChange={e => {
              props.onChange && props.onChange({...question, choices: e as string[]});
            }}
            options={question.options.map((opt, i) => ({
              label: (
                <p style={{marginLeft: 30, marginTop: -30, width: 550, marginBottom: -30, wordWrap: 'break-word', whiteSpace: 'normal'}}>
                  {labels[i]}. {opt}
                </p>
              ),
              value: opt,
            }))}
            value={question.choices}
          />
        )}
        {props.showResult && (
          <div className={'mt-md'}>
            <Text strong className={'mr-md'}>
              正确答案: {question.rightOptions.map(opt => labels[question.options.indexOf(opt)]).sort((a, b) => labels.indexOf(a) - labels.indexOf(b))}
            </Text>
            <Text type={'secondary'}>得分: {question.scoreGet} 分</Text>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
